import axios from 'axios';
import { createAuthInterceptor, getAccessToken } from '@platform/auth-sdk';

const instance = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  timeout: parseInt(import.meta.env.VITE_API_TIMEOUT) || 10000,
  headers: {
    'Accept': 'application/json',
    'Cache-Control': 'no-cache',
    'Pragma': 'no-cache'
  },
  withCredentials: false
});

// Use @platform/auth-sdk interceptor for automatic Bearer token attachment
// and 401 → refresh → retry logic
const { destroy: destroyAuthInterceptor } = createAuthInterceptor(instance, {
  identityCenterUrl: import.meta.env.VITE_IDENTITY_CENTER_URL || 'https://id.digihrms.com',
  getAccessToken: async () => getAccessToken(),
  onAuthFailure: () => {
    // SDK will handle redirect to Identity Center login
    // Clear any residual session data
    sessionStorage.removeItem('user_role');
    sessionStorage.removeItem('sidebarMenus');
  },
});

// Content-Type interceptor for non-FormData requests
instance.interceptors.request.use(
  config => {
    if (!(config.data instanceof FormData)) {
      config.headers['Content-Type'] = 'application/json';
    }
    return config;
  },
  error => Promise.reject(error)
);

export { destroyAuthInterceptor };
export default instance;
